import { render, staticRenderFns } from "./paymentKoPage.vue?vue&type=template&id=2e9cc490&scoped=true&"
import script from "./paymentKoPage.vue?vue&type=script&lang=ts&"
export * from "./paymentKoPage.vue?vue&type=script&lang=ts&"
import style0 from "./paymentKoPage.vue?vue&type=style&index=0&id=2e9cc490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9cc490",
  null
  
)

export default component.exports